import React, { Component } from 'react'
import { observer } from 'mobx-react'
import isArray from 'lodash/isArray'
import uniqBy from 'lodash/uniqBy'
import { Container, Form, Row, Col, Button } from 'react-bootstrap'
import {
  i18nTranslate,
  getLiveEventStatus,
  getLocalStorage,
  setLocalStorage,
  isB2BAccount,
  isB2B2C,
  IS_BROWSER,
  currencyFormat,
  checkMysiteOrPersonalOffer,
  isGPSEnabled,
  trackEnhancedCheckoutEvent,
  trackGTMEvents,
  convertToBoolean,
  getMysiteCartUrl,
  trackMovetoCart,
  trackSaveforLater,
  isToShowOverrideSubscription,
  retriveAgreement,
  checkAgreedTermStatus,
  getLocaleCodeFromUrl,
  trackPathToPurchaseBeginCheckout,
  isINMarket,
} from 'src/utils'
import {
  cartContainer,
  saveForLaterContainer,
  customerContainer,
  checkoutContainer,
  nuskinSubscriptionContainer,
  applepayContainer,
  multipleSubscriptionContainer,
  subscriptionContainer,
  sessionContainer,
  accountsContainer,
} from 'src/models'
import {
  toastState,
  storePickupState,
  productState,
  Summary,
  EmptyCart,
  SigninModal,
  KlarnaMessage,
  ViewCartSearch,
  DrawerModal,
  MultipleSubscriptionCart,
  AddToExistingSubscriptionModal,
  SubscriptionConfirmedModal,
  overlayState,
} from 'src/views/components'
import { CSWrapper } from 'src/views/components/CSWrapper/CSWrapper'
import { Link } from 'react-router-dom'
import { checkIsNativeApp } from 'src/utils/reactNativeAppUtils'
import { getProductDetailsForCart, getProductDetailsForSavedCart } from './deps'
import { CartProductBlock } from './CartProductBlock'
import { FreeGiftCartProductBlock } from './FreeGiftCartProductBlock'
import {
  CheckoutProductBlock,
  renderCartProductsHeader,
} from './CheckoutProductBlock'
import { pageNames } from 'src/routes/pathParams'
import { isEquinoxPOSite } from 'src/utils/mySiteUtils'
import {
  getSeparateCartAndCheckout,
  getSessionStorage,
  useCartTableView,
  APPConfig,
  setSessionStorage,
  isStoreConfigLoaded,
} from 'config/appConfig'
import {
  isFlexibleSubscriptionFlagEnabled,
  isMultipleSubscriptionFlagEnabled,
  isToShowMultipleSubscriptionOptionsInCart,
  isSubscriptionFlagEnabled,
  subscriptionBlackOutDatesV2,
} from 'src/deps'
import TagManager from 'react-gtm-module'
import {
  alertMessageKeys,
  cartCategoryType,
  multipleSubscriptionRadioOptions,
} from './fixture'
import { Checkoutfreegifts } from './CheckoutProductBlock/CheckoutFreeGift'
import { CheckoutNuskinIcon } from 'src/views/components/Icons/CheckoutNuSkinIcon'
import { observable, action } from 'mobx'
import { sendNeedToSignIn } from 'src/utils/reactNativeAppUtils'
import { isObject, trackErrorInInstana } from 'src/utils/commonUtils'
import { PayLaterMessage } from '../PayPal/PayLaterMessage'
import { isPaylaterMessageRequired } from '../PayPal'
import { getAvailablePaymentsForAddNewSections } from 'src/views/components/PaymentListWithForm/fixture'
import PaymentIcon from '../PaymentIcon'
import { MultipleProductSubscriptionModal } from '../SubscriptionComponents/MultipleProductSubscriptionModal'
import { MultiSubscriptionCartDrawer } from '../FlexibleSubscriptionCart'
import { trackInsiderCartEvents, trackInsiderPageView } from 'src/utils/insider'
import { LoyaltyMFEContainer } from 'src/views/components/LoyaltyMFE/LoyaltyMFEContainer'
import {
  enableToshowBlackOutDateSelection,
  isEnableIronCladIntegrationAPI,
} from '../Header/deps'
import {
  getMemberGroupKey,
  loadClickWrapContainer,
  retrieveAccountTypeGroupKey,
  toggleIronCladCheck,
} from 'src/utils/signUpUtils'
import { isEquinoxMysite } from 'src/utils/mySiteUtils'
import './styles.scss'
import { DEFAULT_SPONSOR } from 'src/utils/constant'

@observer
class CartProducts extends Component {
  freeGiftProductsList = []
  @observable isModalVisible = false
  @observable enableBtn = false
  @observable isCheckoutInventory = false
  @observable isToShowSubscriptionModal = false
  @observable enableLiveEvent = getLiveEventStatus()
  isEventRegisteredUser = this.checkEventRegisteredUser()
  @observable isBlackOutDateSubscriptionOptions = false
  // @observable convertAccountType = 'Preferred Customer/Member'
  @observable isHandleClick = false
  checkEventRegisteredUser() {
    const profileResponse = customerContainer?.profileResponse
    const accountProperties = profileResponse?.accounts?.properties || []
    const userProperty = accountProperties?.filter(
      property => property?.attributeId === 'registeredEvent'
    )
    return userProperty?.[0]?.value || 'false'
  }

  @action
  toggleModal = (props = {}) => {
    const { visibility } = props

    this.isModalVisible =
      visibility !== undefined ? visibility : !this.isModalVisible
  }

  toggleSubscriptionModal = () => {
    if (nuskinSubscriptionContainer.isToShowDisabledModal) {
      nuskinSubscriptionContainer.isToShowDisabledModal = false
    } else {
      this.isToShowSubscriptionModal = !this.isToShowSubscriptionModal
      nuskinSubscriptionContainer.enableCartConvertMessage = false
      nuskinSubscriptionContainer.enableGoToCart = false
    }
  }

  formatPrice = (priceLabel = '', value = {}) => {
    let price = value?.[priceLabel] || '0.00'
    if (isNaN(price)) {
      price = '0.00'
    }
    const finalCost = currencyFormat({
      price,
    })
    return finalCost
  }

  getCheckoutPageName = () => {
    return isEquinoxPOSite() ? pageNames.expressCheckout : pageNames.checkout
  }

  componentWillUnmount() {
    this.toggleModal({ visibility: false })
  }

  isCallInProgress = false

  constructor(props) {
    super(props)
    this.quantity = 1
    accountsContainer.signUpIronCladCheck.clickWrap2 = false
  }

  async componentDidMount() {
    multipleSubscriptionContainer.isToShowSubscriptionConfirmedModal = false
    setSessionStorage('isToShowBlackOut', false)
    if (isMultipleSubscriptionFlagEnabled()) {
      const isToShowMultipleSubscriptionOptions =
        isToShowMultipleSubscriptionOptionsInCart() || false
      multipleSubscriptionContainer.isToShowSelectSubscriptionModal =
        isToShowMultipleSubscriptionOptions &&
        multipleSubscriptionContainer.subscriptionOption === 'addToExisting'
    } else {
      this.isToShowSubscriptionModal =
        nuskinSubscriptionContainer.showSubscriptionModal() ||
        nuskinSubscriptionContainer.enableGoToCart
    }
    this.trackInsider()
  }

  getIronCladAccountDetails = () => {
    const siteId = APPConfig?.getAppConfig()?.ironCladSiteAccessId || ''
    const accountReferenceId =
      customerContainer?.profileResponse?.referenceAttribute || ''
    return { siteId, accountReferenceId }
  }

  trackInsider() {
    trackInsiderPageView({ pageType: 'cart' })
    trackInsiderCartEvents({ cartResponse: cartContainer.cartResponse })
  }

  @action
  renderKlarnaMessaging = () => {
    const grandTotal = cartContainer.cartResponse?.value?.grandTotal || 0
    // const grandTotalForKlarna = grandTotal?.toFixed(2)
    return (
      cartContainer.cartCount > 0 && (
        <div className="klarna-message">
          <KlarnaMessage
            id="klarna-cart-message"
            data-key="credit-promotion-badge"
            price={grandTotal}></KlarnaMessage>
        </div>
      )
    )
  }

  handleCartQuantityChange = async (count = 0, itemId = 0) => {
    const cartResponse = cartContainer?.cartResponse?.items || []
    const { isSaveForLater = false } = this.props
    let inventoryerrorcode = cartResponse?.find(
      e => e.errorMessage == 'Item is BackOrdered'
    )
    let inventoryitemId = inventoryerrorcode?.itemId
    if (isSaveForLater) {
      this.quantity = count
    } else {
      if (inventoryitemId) {
        await cartContainer.updateCart({
          id: inventoryitemId,
          quantity: count,
          properties: {
            isBackOrdered: true,
          },
        })
      } else {
        const response = await cartContainer.updateCart({
          id: itemId,
          quantity: count,
        })
        const InventoryResponse = cartContainer?.inventoryResponse || {}
        if (InventoryResponse.message == 'Item is BackOrdered') {
          await cartContainer.updateCart({
            id: itemId,
            quantity: count,
            properties: {
              isBackOrdered: true,
            },
          })
        }
        overlayState.hideLoader()
        return response
      }
      overlayState.hideLoader()
    }
  }

  scanQualifiedCount = () => {
    let scanQualifiedProducts = cartContainer?.scanQualifiedProducts || []
    let quantityChange = this.scanCount || 0
    let counts = []
    let scanDetails = {}
    let scanCounts = []
    let n = 0
    scanQualifiedProducts?.map(item => {
      let skuScanCount = 0
      item?.skus?.forEach(sku => {
        skuScanCount = sku?.skuProperties
          ? sku?.skuProperties?.scanQualifiedCount
          : skuScanCount
      })
      scanDetails = {
        itemId: item?.itemId || '',
        scanCount: skuScanCount || 0,
        quantity: item?.quantity || 0,
      }
      if (item?.itemId === quantityChange?.itemId) {
        scanCounts.push(parseInt(skuScanCount) * quantityChange?.quantity)
        if (quantityChange?.quantity > item?.quantity) {
          let diff =
            quantityChange?.quantity > item?.quantity
              ? quantityChange?.quantity - item?.quantity
              : item?.quantity - quantityChange?.quantity
          n =
            cartContainer?.scanCardVisibilityCount +
            parseInt(skuScanCount) * diff
          cartContainer.updateScanvisibilityCount(n)
        } else {
          if (quantityChange?.quantity < item?.quantity) {
            let diff = item?.quantity - quantityChange?.quantity
            let count = parseInt(skuScanCount) * diff
            cartContainer.updateScanvisibilityCount(n)
            n =
              cartContainer?.scanCardVisibilityCount > count
                ? cartContainer?.scanCardVisibilityCount - count
                : count - cartContainer?.scanCardVisibilityCount
            //cartContainer.scanCardVisibilityCount - count
          }
        }
        scanDetails.quantity = quantityChange?.quantity
      } else {
        scanCounts.push(parseInt(skuScanCount) * item?.quantity)
      }
      counts.push(scanDetails)
    })

    let scanCountSum = scanCounts.reduce(function (a, b) {
      return parseInt(a) + parseInt(b)
    }, 0)
    return scanCountSum
  }

  handleSubscriptionChange = async (
    count = 0,
    itemId = 0,
    subscription = {}
  ) => {
    const response = await cartContainer.updateCart({
      id: itemId,
      quantity: count,
      subscription: subscription,
    })
    return cartContainer.isSuccessResponse(response) ? true : false
  }

  handlePickupDelete = (skuId = '') => {
    const storeProductsInCookie = getLocalStorage('storeProducts') || {}
    if (storePickupState.storePickupProducts.hasOwnProperty(skuId)) {
      productState.selectPickupType = 'ship-it'
      delete storePickupState.storePickupProducts[skuId]
    }
    if (storeProductsInCookie && storeProductsInCookie.hasOwnProperty(skuId)) {
      delete storeProductsInCookie[skuId]
      setLocalStorage('storeProducts', storeProductsInCookie)
    }
  }

  handleSubscribeCheckboxClick = async (
    subscriptionData = {},
    enableToastMessage = true
  ) => {
    const { id = '' } = subscriptionData || {}
    const activeElementId = document.activeElement?.id
    const shouldRestoreFocus =
      activeElementId && activeElementId.includes('subscribe-checkbox')

    const response = await cartContainer.updateCart(
      subscriptionData,
      enableToastMessage
    )
    const { type = '' } = subscriptionData || {}
    const isFlexibleSubscriptionEnabled =
      isFlexibleSubscriptionFlagEnabled() || false
    if (
      cartContainer.isSuccessResponse(response) &&
      type === 'subscription' &&
      isFlexibleSubscriptionEnabled
    ) {
      const items = cartContainer.cartResponse?.items || []
      const cartItem = items.find(item => item.itemId === id)
      const name =
        cartContainer.cartResponse?.items?.[0]?.skus?.[0]?.skuProperties
          ?.name || ''
      const {
        itemId = '',
        totalValue = {},
        quantity = '',
        subscription = {},
        isSubscription = false,
      } = cartItem || {}

      trackGTMEvents({
        event: 'subscriptionSubscribeCheck',
        item_id: itemId,
        item_name: name,
        discount: totalValue?.discount,
        total: totalValue?.grandTotal,
        quantity: quantity,
        frequency:
          subscription?.frequencyPeriod + '-' + subscription?.frequencyType,
      })
    }

    // Restore focus to the checkbox after cart update
    if (shouldRestoreFocus && IS_BROWSER) {
      setTimeout(() => {
        const checkboxId = `subscribe-checkbox-${id}`
        const checkbox = document.getElementById(checkboxId)
        if (checkbox) {
          checkbox.focus()
        }
      }, 100)
    }
  }

  handleDeleteCartItem = async (props = {}) => {
    const {
      isSaveForLater = false,
      listItemId = '',
      cartItemId = 0,
      skuId = '',
      productId = '',
      slug,
      productName,
      isSubscription = false,
      currency = '',
      categoryId = '',
      totalPrice = '',
      variantLabel = '',
      quantity = '',
    } = props
    if (isSaveForLater) {
      await saveForLaterContainer.deleteProductFromList(listItemId)
    } else {
      this.handlePickupDelete(skuId)
      const productData = {
        skuId,
        productName,
        currency,
        categoryId,
        totalPrice,
        quantity,
        variantLabel,
      }
      await cartContainer.deleteCartItem(
        productId,
        isSubscription,
        cartItemId,
        true,
        skuId,
        slug,
        productName,
        productData
      )
    }
  }

  handleSaveForLaterItem = async (props = {}) => {
    const {
      isSaveForLater = false,
      listItemId = '',
      cartItemId = 0,
      quantity = 0,
      isCheckout = false,
      skuId = '',
      ...remainingProps
    } = props
    if (this.isCallInProgress === false) {
      this.isCallInProgress = true
      if (isSaveForLater) {
        // Move to Cart
        const moveToCartProps = [
          {
            quantity,
            skuId,
            ...remainingProps,
          },
        ]
        const response = await cartContainer.addToCart(
          { cartArray: moveToCartProps, isCheckout, isShowToast: false },
          false
        )
        if (cartContainer.isSuccessResponse(response)) {
          await saveForLaterContainer.deleteProductFromList(listItemId, false)
          toastState.setToastMessage(
            i18nTranslate(
              'cart.moveToCartSuccess',
              'Product added to cart successfully'
            ),
            true
          )
          trackMovetoCart(props)

          if (IS_BROWSER && skuId) {
            cartContainer.hasPendingFocusManagement = true
            requestAnimationFrame(() => {
              const targetButton = document.getElementById(
                `saveforlater-btn-${skuId}`
              )
              if (targetButton) targetButton.focus()
              cartContainer.hasPendingFocusManagement = false
            })
          }
        } else {
          let errorMessage =
            (response && response?.message) ||
            i18nTranslate(
              'cart.moveToCartFailure',
              'Unable to add product to cart, please try again'
            )
          if (response?.code == 'EOCA0000013') {
            errorMessage = i18nTranslate(
              'cart.moveToCartBackorderMsg',
              'Backordered item cannot be added to cart from save for later and list section'
            )
          } else if (response?.code === 'EOCACG0001') {
            errorMessage = i18nTranslate(
              'cart.unableToProcessError',
              'We are currently unable to process your request or it may already be processed. Please refresh your screen and try again'
            )
          }
          toastState.setToastMessage(errorMessage, false)
        }
      } else {
        // Save For Later
        const response = await saveForLaterContainer.addProductToList({
          ...remainingProps,
          skuId,
          quantity,
        })
        trackErrorInInstana({
          errorReport: 'Save For Later Response',
          errorData: response,
        })
        if (saveForLaterContainer.isSuccessResponse(response)) {
          const isShowToast = false
          await cartContainer.deleteCartItem(
            '',
            '',
            cartItemId,
            isShowToast,
            false
          )
          trackErrorInInstana({
            errorReport: `Save For Later Success - ${cartItemId}`,
            errorData: response,
          })
          toastState.setToastMessage(
            i18nTranslate(
              'cart.savedToCartSuccess',
              'Product moved to save for later successfully'
            ),
            true
          )
          trackSaveforLater(props)

          if (IS_BROWSER && skuId) {
            cartContainer.hasPendingFocusManagement = true
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                const targetButton = document.getElementById(
                  `movetocart-btn-${skuId}`
                )
                if (targetButton) {
                  targetButton.focus()
                }
                cartContainer.hasPendingFocusManagement = false
              })
            })
          }
        } else if (response?.code === 'EOLISIT00001') {
          trackErrorInInstana({
            errorReport: 'Save For Later Failure',
            errorData: response,
          })
          await cartContainer.deleteCartItem('', '', cartItemId, false)
          toastState.setToastMessage(response?.message, false)
        } else if (response?.code === 'EOCACG0001') {
          trackErrorInInstana({
            errorReport: 'Save For Later Failure',
            errorData: response,
          })
          const unProcessableRequestMessage = i18nTranslate(
            'cart.unableToProcessError',
            'We are currently unable to process your request or it may already be processed. Please refresh your screen and try again'
          )
          toastState.setToastMessage(unProcessableRequestMessage, false)
        } else {
          trackErrorInInstana({
            errorReport: 'Save For Later Failure',
            errorData: response,
          })
          const errorMessage =
            response?.message ||
            i18nTranslate(
              'cart.savedToCartFailure',
              'Unable to move product to save for later, please try again'
            )
          toastState.setToastMessage(errorMessage, false)
        }
      }
      this.isCallInProgress = false
    }
  }

  handleSaveForLater = (props = {}) => {
    const { productName = '', ...remainingProps } = props
    this.handleSaveForLaterItem({
      ...remainingProps,
      name: productName,
    })
    customerContainer.isSubscriptionAdded = false
  }

  getHandlers = () => {
    const handlers = {
      handleCartQuantityChange: this.handleCartQuantityChange,
      handleDeleteCartItem: this.handleDeleteCartItem,
      handleSaveForLater: this.handleSaveForLater,
      handleSubscriptionChange: this.handleSubscriptionChange,
      handleSubscribeCheckboxClick: this.handleSubscribeCheckboxClick,
    }
    return handlers
  }

  renderProductBlock = (cartProduct = {}) => {
    const { isSaveForLater = false } = this.props
    const productDetails = isSaveForLater
      ? getProductDetailsForSavedCart(cartProduct, this.props)
      : getProductDetailsForCart(cartProduct, this.props)
    const skus = cartProduct?.skus || []
    const type = cartContainer.getSpecialProductType(skus)
    if (productDetails?.isCheckout) {
      const { isReviewSection = false } = this.props
      if (productDetails?.isFreeGift) {
        let skuId = cartProduct?.skus?.[0]?.skuId || ''
        return (
          <Checkoutfreegifts
            {...productDetails}
            {...cartContainer.getCombineFreeGiftQty(
              skuId,
              this.freeGiftProductsList
            )}
            isNativeApp={this.props?.isNativeApp}
          />
        )
      }
      return (
        <CheckoutProductBlock
          key={`checkout-${cartProduct?.itemId}`}
          isReviewSection={isReviewSection}
          {...productDetails}
          {...this.getHandlers()}
          updateCheckoutBtn={this.props?.updateCheckoutBtn}
          type={type}
          freeGiftProductsList={this.freeGiftProductsList}
          isNativeApp={this.props?.isNativeApp}
        />
      )
    } else {
      if (productDetails?.isFreeGift) {
        let skuId = cartProduct?.skus?.[0]?.skuId || ''
        return (
          <FreeGiftCartProductBlock
            {...productDetails}
            {...cartContainer.getCombineFreeGiftQty(
              skuId,
              this.freeGiftProductsList
            )}
          />
        )
      }
      return (
        <CartProductBlock
          key={`cart-${cartProduct?.itemId}`}
          {...productDetails}
          {...this.getHandlers()}
          type={type}
          isViewCart={true}
          freeGiftProductsList={this.freeGiftProductsList}
        />
      )
    }
  }

  handleSubmit = val => {
    this.isBlackOutDateSubscriptionOptions = val
    nuskinSubscriptionContainer.isToShowBlackOut = val
    setSessionStorage('isToShowBlackOut', val)
  }
  selectBlackOutDateSubscriptionOptions = (defaultProcessingDate = 28) => {
    return (
      <div className="view-cart-wrapper" tabIndex={0}>
        <Container fluid className="black-out-container">
          <p className="subscription-blackout-title">
            {i18nTranslate(
              'subscription_detected_prompt',
              "We noticed you're subscribing. Do you want to"
            )}
            :
          </p>
          <Form>
            <Row>
              <Col xs={12} md={12}>
                <Form.Group
                  tabIndex={0}
                  className={`mb-3 black-out-radio-button ${!this.isBlackOutDateSubscriptionOptions ? 'bo-radio-color' : ''}`}>
                  <Form.Check
                    tabIndex={0}
                    type="radio"
                    id="next-shipment"
                    label={i18nTranslate(
                      'add_to_next_subscription_shipment',
                      'Add to Next Subscription Shipment'
                    )}
                    name="subscriptionOption"
                    defaultChecked={!this.isBlackOutDateSubscriptionOptions}
                    onChange={() => this.handleSubmit(false)}
                  />
                </Form.Group>
              </Col>

              <Col xs={12} md={12}>
                <Form.Group
                  tabIndex={0}
                  className={`mb-3 black-out-radio-button ${this.isBlackOutDateSubscriptionOptions ? 'bo-radio-color' : ''}`}>
                  <Form.Check
                    tabIndex={0}
                    type="radio"
                    id="ship-today"
                    label={
                      <>
                        {i18nTranslate(
                          'ship_new_subscription_order',
                          ' Ship New Subscription Items Today'
                        )}
                        <br />
                        <small>
                          {i18nTranslate(
                            'monthly_order_processing_date',
                            'Subsequent orders will process on the {{date}}th of every month'
                          ).replace('{{date}}', defaultProcessingDate)}
                        </small>
                      </>
                    }
                    name="subscriptionOption"
                    defaultChecked={this.isBlackOutDateSubscriptionOptions}
                    onChange={() => this.handleSubmit(true)}
                  />
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Container>
      </div>
    )
  }
  renderProductBlockView = () => {
    const { isSaveForLater = false } = this.props
    const items = isSaveForLater
      ? saveForLaterContainer?.saveForLaterListProducts || []
      : cartContainer?.cartResponse?.items || []
    const typeObj = {}

    const isToShowNewDesign = isSubscriptionFlagEnabled() || false
    const isSubscriptionOverridePage = isToShowOverrideSubscription()

    let filterProductByType = function (typeObject, type, item) {
      if (type in typeObject) {
        let subProd = typeObject[type]
        subProd.push(item)
        typeObject[type] = subProd
      } else {
        let subProd = []
        subProd.push(item)
        typeObject[type] = subProd
      }
    }
    items?.map(item => {
      if (item?.properties?.isGiftItem) {
        filterProductByType(typeObj, 'typeGift', item)
      } else if (item?.isSubscription) {
        filterProductByType(typeObj, 'subscriptionType', item)
      } else {
        filterProductByType(typeObj, 'oneTimeType', item)
      }
    })
    const orderedObj = Object.keys(typeObj)
      ?.sort()
      ?.reduce((obj, key) => {
        obj[key] = typeObj[key]
        return obj
      }, {})
    this.freeGiftProductsList = orderedObj?.typeGift || []
    if (
      typeof orderedObj?.typeGift !== 'undefined' &&
      orderedObj?.typeGift?.length > 0
    ) {
      orderedObj.typeGift = uniqBy(
        orderedObj?.typeGift,
        freeGift => freeGift?.skus?.[0]?.skuId
      )
    }
    const categoryProduct = []
    if (isSubscriptionOverridePage && items?.length) {
      categoryProduct.push(
        <div
          className={`cart-item-category-heading view-cart-category font-weight-bold h4 heading-5 text-uppercase mt-2 mb-2`}
          data-testid="qa-minicart-title">
          {i18nTranslate('subscriptionCart.itemTitle', 'ITEMS')}
        </div>
      )
    }
    for (let key in orderedObj) {
      if (orderedObj.hasOwnProperty(key)) {
        let value = orderedObj[key]
        const isFreeGift = key == 'typeGift'
        const freeGiftClass = isFreeGift ? 'text-success' : ''
        if (isArray(value) && value?.length > 0) {
          categoryProduct.push(
            <>
              {(!isSubscriptionOverridePage || isFreeGift) &&
                !isSaveForLater && (
                  <div
                    className={`cart-item-category-heading view-cart-category font-weight-bold h4 heading-5 mt-2 mb-2 ${freeGiftClass}`}
                    data-testid="qa-minicart-title"
                    data-section-type={isFreeGift ? 'gift' : ''}>
                    <h3>{cartCategoryType(isToShowNewDesign)[key].value}</h3>
                  </div>
                )}
              {value?.map(this.renderProductBlock)}
            </>
          )
        }
      }
    }
    return categoryProduct
  }

  onContinue = () => {
    this.props.history.push(this.getCheckoutPageName())
  }

  paypalCheckout = async () => {
    await checkoutContainer.paypalCheckoutEnable(true)
    checkoutContainer.applePayCheckout = false
    checkoutContainer.gPayCheckout = false
    this.handleClick()
  }

  applePayCheckout = async () => {
    await checkoutContainer.applePayCheckoutEnable(true)
    checkoutContainer.paypalCheckout = false
    checkoutContainer.gPayCheckout = false
    this.handleClick()
  }

  gPayCheckout = async () => {
    await checkoutContainer.gPayCheckoutEnable(true)
    checkoutContainer.paypalCheckout = false
    checkoutContainer.applePayCheckout = false
    this.handleClick()
  }

  checkoutDisable = () => {
    const checkoutDisableInfo = { isDisabled: false, message: '' }
    const isFlexibleSubscriptionEnabled =
      isFlexibleSubscriptionFlagEnabled() || false
    const itemDetails = cartContainer?.cartResponse?.items || []

    const isToShowMultipleSubscriptionOptions =
      isToShowMultipleSubscriptionOptionsInCart()
    const isToShowAddToSubscriptionDrawer =
      multipleSubscriptionContainer.subscriptionOption === 'addToExisting'
    const isToEnableCheckoutForOOSSubscriptionMS =
      isToShowMultipleSubscriptionOptions && isToShowAddToSubscriptionDrawer

    if (itemDetails?.length === 0) {
      checkoutDisableInfo.isDisabled = true
    } else if (isToEnableCheckoutForOOSSubscriptionMS) {
      checkoutDisableInfo.isDisabled = false
    } else if (this.props?.orderHoldStatus) {
      checkoutDisableInfo.isDisabled = true
      checkoutDisableInfo.message = i18nTranslate(
        'account.onhold',
        'Account is on hold'
      )
    }
    // else if (
    //   accountsContainer.showIroncladCheckbox &&
    //   !accountsContainer.isMemberAgreementChecked
    // ) {
    //   checkoutDisableInfo.isDisabled = true
    // }
    else if (
      // enable checkout button when cart is having subscription items
      // and user is having subscription dashboard already
      // and when flexible subscription flag is enabled
      nuskinSubscriptionContainer.isUserSubscribedBefore() &&
      cartContainer.hasSubscriptionProduct() &&
      isFlexibleSubscriptionEnabled
    ) {
      checkoutDisableInfo.isDisabled = false
    } else {
      const isSkuNotAvailable = (inventory = {}) =>
        inventory?.available === false &&
        (inventory?.backOrdered === false || inventory?.backOrdered === null)

      const isSomeSkuNotAvailable = itemDetails?.some(item => {
        const { skus = [] } = item
        return skus?.some(newitem => {
          return isSkuNotAvailable(newitem?.inventoryProperties)
        })
      })

      if (isSomeSkuNotAvailable) {
        checkoutDisableInfo.isDisabled = true
        checkoutDisableInfo.message = i18nTranslate(
          'some.items.unavailable',
          'Some of the items are not available.'
        )
      } else if (cartContainer?.cartResponse?.errorCode) {
        checkoutDisableInfo.isDisabled = true
        if (cartContainer.cartResponse?.errorCode === 'EOPLOR001') {
          checkoutDisableInfo.message = i18nTranslate(
            'cart.homeMarket',
            'Please switch to your home market to make a purchase.'
          )
        } else if (cartContainer.cartResponse?.errorCode === 'EOSKUPS002') {
          checkoutDisableInfo.message = i18nTranslate(
            'bundle.discontinuedV2Message',
            'Discontinued - This product or promotion has been discontinued',
            {
              nameSpace: 'ssr-resource',
            }
          )
        } else {
          checkoutDisableInfo.message = cartContainer.cartResponse.errorMessage
        }
      }

      // Disable checkout conditions for Live Event
      // CN locale users might get migrated for the July event site
      // Checkout is disabled for them for non-event sites
      const homeCountry = customerContainer?.getUserHomeCountry()
      const isUserFromCN = homeCountry === 'CN'
      if (this.enableLiveEvent !== 'true') {
        if (isUserFromCN) {
          checkoutDisableInfo.isDisabled = true
          checkoutDisableInfo.message = i18nTranslate(
            'cart.homeMarket',
            'Please switch to your home market to make a purchase.'
          )
        }
      }
      if (this.enableLiveEvent === 'true') {
        const isEventUnregisteredUser =
          customerContainer.isRegisterUser &&
          this.isEventRegisteredUser === 'false'
        const isRetailUser =
          customerContainer?.profileResponse?.accounts?.accountType ===
          'Retail Customer'

        // Disable checkout in event for unregistered users and retail users from CN
        if (isEventUnregisteredUser || (isUserFromCN && isRetailUser)) {
          checkoutDisableInfo.isDisabled = true
        }
      }
    }
    return checkoutDisableInfo
  }

  renderCartViewButtons = () => {
    let contextValue
    let hideContinueShopBtn
    try {
      if (typeof window !== 'undefined') {
        // const shoppingContext = getLocalStorage('shoppingContext') || {}
        contextValue = checkMysiteOrPersonalOffer()
        // if (Object.keys(shoppingContext).length > 0) {
        // contextValue = shoppingContext?.context || ''
        if (
          contextValue === 'personal_offer' ||
          contextValue === 'storefront'
        ) {
          /**
           *style for hide continue shopping button
           */
          hideContinueShopBtn = {
            display: 'none',
          }
        }
        // }
      }
    } catch (e) {
      console.error('JSON.parse error at renderCartViewButtons >>> ', e)
    }

    const checkoutDisableInfo = this.checkoutDisable()
    let subsctiptionItemsTotal =
      cartContainer.cartResponse?.properties?.subsctiptionItemsTotal || '0'
    let grandTotal = cartContainer?.cartResponse?.value?.grandTotal || ''
    const cartProductsCount = cartContainer?.cartCount
    const userCountry = customerContainer.getUsersCountry()
    const isGPSEnabledAndDefault = isGPSEnabled()
    let hasSubscriptionProductInCart =
      cartContainer.hasSubscriptionProduct() || false
    const isToEnableExpressPaymentOptions =
      APPConfig?.getAppConfig()?.expressPayments || []

    const isToEnableExpressPaymentOption = (paymentType = '') => {
      return isToEnableExpressPaymentOptions?.includes?.(
        paymentType?.toUpperCase()
      )
    }
    const isToEnablePaypal =
      getAvailablePaymentsForAddNewSections({
        paymentType: 'payPal',
      }) || false

    const isToEnableApplePay =
      getAvailablePaymentsForAddNewSections({
        paymentType: 'applePay',
      }) || false

    const isToEnableGooglePayPayment =
      getAvailablePaymentsForAddNewSections({
        paymentType: 'googlePay',
      }) || false

    const isToEnableGooglePayForNativeApps =
      convertToBoolean(
        APPConfig?.getAppConfig()?.enableGooglePayPaymentForNativeApps
      ) || false
    let isNativeApp = this.props?.isNativeApp || false

    let isToEnableGooglePay = isNativeApp
      ? isToEnableGooglePayForNativeApps && isToEnableGooglePayPayment
      : isToEnableGooglePayPayment

    const isCurrentDeviceSupportedApplePay =
      applepayContainer.checkIfDeviceSupportsApplePay()

    const isToShowExpressPayPal =
      isToEnablePaypal &&
      !hasSubscriptionProductInCart &&
      !isGPSEnabledAndDefault &&
      isToEnableExpressPaymentOption('PAYPAL')

    const isToShowExpressApplePay =
      isToEnableApplePay &&
      !hasSubscriptionProductInCart &&
      !isGPSEnabledAndDefault &&
      isCurrentDeviceSupportedApplePay &&
      isToEnableExpressPaymentOption('APPLEPAY')

    const isToShowExpressGooglePay =
      isToEnableGooglePay &&
      !hasSubscriptionProductInCart &&
      !isGPSEnabledAndDefault &&
      isToEnableExpressPaymentOption('GOOGLEPAY')

    const isToShowNewDesign = isSubscriptionFlagEnabled() || false

    const isToShowExpressPayments =
      grandTotal > 0 &&
      (isToShowExpressPayPal ||
        isToShowExpressApplePay ||
        isToShowExpressGooglePay)

    const isSubscriptionOverridePage = isToShowOverrideSubscription()
    const isToShowContinueShoppingButton =
      !this.props?.isNativeApp &&
      cartProductsCount === 0 &&
      !isSubscriptionOverridePage

    return (
      <div className="cart-view-button-wrapper">
        {isToShowContinueShoppingButton && (
          <Row noGutters className=" mt-3 flex-row justify-content-end w-100">
            <Col lg={12} className="px-2">
              {/* dont use anchor tags use link or history push and fix any issue in it*/}
              <Link
                to={pageNames.home}
                // onClick={() => (window.location.href = window.location.origin)}
                // href="javascript:;"
                className="cart-view-button-link mr-lg-3">
                {/* <Link to={pageNames.home} className="cart-view-button-link mr-lg-3"> */}
                <Button
                  variant="primary"
                  className="cart-view-continue-shopping-button w-100 mr-2 mb-2"
                  style={hideContinueShopBtn}
                  data-testid="qa-cart-continue-shopping">
                  {i18nTranslate('cart.continueShopping', 'Continue Shopping')}
                </Button>
              </Link>
            </Col>
          </Row>
        )}
        <Row noGutters className="flex-row justify-content-end w-100">
          <Col lg={12}>
            <Button
              variant="primary"
              disabled={checkoutDisableInfo?.isDisabled}
              className="cart-view-checkout-button mr-2 w-100"
              data-testid="qa-cart-checkout"
              onClick={() => {
                this.handleClick()
                checkoutContainer.paypalCheckoutEnable(false)
                checkoutContainer.applePayCheckoutEnable(false)
                checkoutContainer.gPayCheckoutEnable(false)
              }}>
              {isToShowNewDesign ? (
                <div>
                  <span>
                    <CheckoutNuskinIcon
                      className="view-cart-nuskin"
                      width="24px"
                      height="24px"
                      fill="#ffffff"
                    />
                  </span>
                  <span>{i18nTranslate('cart.checkout', 'Checkout')}</span>
                </div>
              ) : (
                i18nTranslate('cart.checkout', 'Checkout')
              )}
            </Button>
            <p className="text-danger view-cart-error-message">
              {alertMessageKeys(checkoutDisableInfo?.message)}
            </p>
          </Col>
          {isToShowExpressPayments && (
            <Col lg={12}>
              <span className="divider-viewcart">Or</span>
            </Col>
          )}
          {isToShowExpressApplePay && grandTotal > 0 && (
            <Col lg={12}>
              <Button
                variant="outline-primary"
                onClick={this.applePayCheckout}
                className="express-applepay-btn mb-2"
                disabled={checkoutDisableInfo?.isDisabled}
                aria-label={i18nTranslate('checkout.applepayText', 'applepay')}>
                <PaymentIcon type="express-applepay-btn" />
              </Button>
            </Col>
          )}
          {isToShowExpressGooglePay && grandTotal > 0 && (
            <Col lg={12}>
              <Button
                variant="outline-primary"
                onClick={this.gPayCheckout}
                className="express-gpay-btn mb-2"
                data-testid="qa-cart-express-google-pay"
                disabled={checkoutDisableInfo?.isDisabled}
                aria-label={i18nTranslate(
                  'checkout.googlepayText',
                  'googlepay'
                )}>
                <PaymentIcon type="express-gpay-btn" />
              </Button>
            </Col>
          )}

          {isToShowExpressPayPal && grandTotal > 0 && (
            <>
              {this.enableLiveEvent !== 'true' && (
                <Col lg={12}>
                  <Button
                    variant="outline-primary"
                    onClick={this.paypalCheckout}
                    className="paypal-btn mb-2"
                    disabled={checkoutDisableInfo?.isDisabled}
                    data-testid="qa-cart-express-paypal"
                    aria-label={i18nTranslate('checkout.paypalText', 'PayPal')}>
                    <PaymentIcon type="paypalCart" />
                  </Button>
                </Col>
              )}
              <Col lg={12}>
                {isPaylaterMessageRequired(userCountry) && (
                  <PayLaterMessage
                    amount={grandTotal}
                    id={'cart-paylater'}
                    key={'cart-paylater'}
                  />
                )}
              </Col>
            </>
          )}
        </Row>
      </div>
    )
  }

  /**
   * Renders the flexible subscription modal if there are any
   * subscription items in the cart.
   *
   * Gets the cart items, filters for subscription items,
   * checks if there are any, and conditionally renders the
   * MultiSubscriptionCartDrawer component passing the subscription
   * items and props.
   */

  isCheckAlreadySubscribed = () => {
    const cartItems = cartContainer?.cartResponse?.items || []
    const convertedSubscriptionList =
      this.convertSingleSubscriptionListArray() || {}
    let isSubscriptionData = []
    const isAlreadySubscribed = cartItems?.some(
      ({ skus = [], isSubscription = false }) => {
        if (isSubscription) {
          let isMatchSkuId = false
          let isSubscriptionData = skus?.some(sku => {
            const skuId = sku?.skuId || ''
            if (Object.keys(convertedSubscriptionList).length > 0) {
              if (
                Object.hasOwn(convertedSubscriptionList, skuId) &&
                !isMatchSkuId
              ) {
                isMatchSkuId = true
                return true
              }
            }
          })
          return isSubscriptionData
        }
      }
    )

    return isAlreadySubscribed
  }

  convertSingleSubscriptionListArray = () => {
    const subscriptionList =
      nuskinSubscriptionContainer.getSubscriptionList() || []

    if (Array.isArray(subscriptionList) && subscriptionList?.length > 0) {
      return subscriptionList.reduce((acc, { itemInfo = [] }) => {
        itemInfo.forEach(({ skus = [] }) => {
          skus.forEach(sku => {
            const skuId = sku?.id || ''
            if (skuId) acc[skuId] = sku // Add SKU to the result if skuId exists
          })
        })
        return acc
      }, {})
    }
  }
  renderFlexibleSubscriptionModal = () => {
    const cartItems = cartContainer?.cartResponse?.items || []
    if (Array.isArray(cartItems) && cartItems?.length > 0) {
      let subscriptionItems = cartItems?.filter(
        item => item?.isSubscription === true
      )

      const isCartHasSubscriptionProducts =
        cartContainer.hasSubscriptionProduct() || false

      return (
        isCartHasSubscriptionProducts &&
        subscriptionItems.length > 0 && (
          <MultiSubscriptionCartDrawer
            subscriptionItems={[...subscriptionItems]}
            toggleSubscriptionModal={this.toggleSubscriptionModal}
            {...this.props}
          />
        )
      )
    }
  }

  handleClick = () => {
    const cartItems = cartContainer?.cartResponse?.items || []
    const cartValue = cartContainer?.cartResponse?.value || {}
    if (customerContainer?.isRegisterUser) {
      const accountType =
        customerContainer?.profileResponse?.accounts?.accountType || ''
      const isBA =
        accountType === 'Brand Affiliate' ||
        accountType === 'Brand Affiliate - Business Entity'
      trackPathToPurchaseBeginCheckout({
        responseData: cartItems,
        sponsorId:
          accountsContainer?.getAccountSponsorId?.() || DEFAULT_SPONSOR,
        discount: cartValue?.itemDiscount || 'NA',
        item_list_name: 'cart_checkout',
        item_persistent: false,
        totalValue: cartValue?.grandTotal || 0,
      })
    }
    this.isHandleClick = true
    setLocalStorage('IsCheckoutClicked', true)
    const itemdetails = cartContainer?.cartResponse?.items || {}
    itemdetails
      ?.filter(itemdata => itemdata?.errorMessage === 'Item is BackOrdered')
      ?.map(
        async filtereddata =>
          await cartContainer.updateCart({
            id: filtereddata?.itemId,
            properties: {
              isBackOrdered: true,
            },
          })
      )
    const cartResponse = cartContainer?.cartResponse || {}
    //CX16-9906 - Show subscription modal(including oos) when user is having subscription dashboard already
    // and cart contains subscription items and flexible subscription feature is enabled
    // remaining error conditions handled in else if part

    const isFlexibleSubscriptionEnabled =
      isFlexibleSubscriptionFlagEnabled() || false
    const isMultipleSubscriptionEnabled =
      isMultipleSubscriptionFlagEnabled() || false

    const isToShowMultipleSubscriptionOptions =
      isToShowMultipleSubscriptionOptionsInCart()
    const isToShowAddToSubscriptionDrawer =
      multipleSubscriptionContainer.subscriptionOption === 'addToExisting'
    const isAlreadySubscription = enableToshowBlackOutDateSelection()
      ? this.isCheckAlreadySubscribed()
      : false
    const isToShowFlexibleSubscriptionModal =
      (nuskinSubscriptionContainer.showSubscriptionModal() ||
        nuskinSubscriptionContainer.enableGoToCart) &&
      !isMultipleSubscriptionEnabled &&
      (!this.isBlackOutDateSubscriptionOptions || isAlreadySubscription)
    const isSubscriptionOverridePage = isToShowOverrideSubscription()

    if (
      nuskinSubscriptionContainer.isUserSubscribedBefore() &&
      cartContainer.hasSubscriptionProduct() &&
      isFlexibleSubscriptionEnabled &&
      !this.isBlackOutDateSubscriptionOptions
    ) {
      this.toggleSubscriptionModal()
    } else if (
      isToShowAddToSubscriptionDrawer &&
      isToShowMultipleSubscriptionOptions
    ) {
      multipleSubscriptionContainer.isToShowSelectSubscriptionModal = true
      return
    } else if (cartResponse?.errorCode) {
      this.isCheckoutInventory = true
      checkoutContainer.paypalCheckoutEnable(false)
      checkoutContainer.applePayCheckoutEnable(false)
      checkoutContainer.gPayCheckoutEnable(false)
    }

    if (!this.isCheckoutInventory) {
      itemdetails?.forEach(item => {
        const { skus = [], errorCode = '' } = item
        skus.forEach(newitem => {
          let inventory = newitem?.inventoryProperties
          let inventoryStatus =
            inventory?.available === false &&
            inventory?.backOrdered === true &&
            errorCode
          this.isCheckoutInventory = inventoryStatus
          if (inventoryStatus === true) {
            toastState.setToastMessage('Item is BackOrdered')
            checkoutContainer.paypalCheckoutEnable(false)
            checkoutContainer.applePayCheckoutEnable(false)
            checkoutContainer.gPayCheckoutEnable(false)
          }
        })
      })
    }
    if (!this.isCheckoutInventory) {
      if (isStoreConfigLoaded() && isB2BAccount() && !isB2B2C()) {
        const costCenterId = cartContainer?.cartResponse?.costCenterId || ''
        if (costCenterId) {
          this.props.history.push(this.getCheckoutPageName())
        } else {
          toastState.setToastMessage(
            i18nTranslate(
              'cart.costcentererrormessage',
              'Please choose a cost center to proceed'
            )
          )
          trackErrorInInstana({
            errorReport: 'Please choose a cost center to proceed',
            errorData: {
              isRegisterUser: customerContainer?.isRegisterUser,
              accountType:
                customerContainer?.profileResponse?.accounts?.accountType || '',
              cartId: cartContainer?.cartResponse?.cartId || '',
              cartCount: cartContainer?.cartCount || 0,
              costCenterId: costCenterId,
            },
          })
          checkoutContainer.paypalCheckoutEnable(false)
          checkoutContainer.applePayCheckoutEnable(false)
          checkoutContainer.gPayCheckoutEnable(false)
        }
      } else if (getSeparateCartAndCheckout() === true) {
        if (customerContainer?.isRegisterUser) {
          if (isToShowFlexibleSubscriptionModal) {
            this.isToShowSubscriptionModal = true
          } else if (isSubscriptionOverridePage) {
            this.props.history?.push(pageNames.subscriptionCheckout)
          } else {
            this.isToShowSubscriptionModal = false
            if (this.isBlackOutDateSubscriptionOptions) {
              this.props.history?.push(this.getCheckoutPageName())
            } else {
              if (this.props?.isNativeApp === true) {
                this.props.history?.push(
                  `${this.getCheckoutPageName()}?isNativeApp=true`
                )
              } else {
                this.props.history?.push(this.getCheckoutPageName())
              }
            }

            if (this.enableLiveEvent === 'true') {
              const values = cartContainer?.cartResponse?.value || {}
              trackEnhancedCheckoutEvent({
                type: 'begin_checkout',
                action: { step: '1' },
                products: itemdetails,
                value: values?.grandTotal || '',
              })
            }
            TagManager.dataLayer({
              dataLayer: {
                event: 'checkout button',
                pageTitle: 'viewCart',
                pagePath: '/viewCart',
                cartType: cartResponse?.cartType || '',
                productLength: cartResponse?.value?.count || '',
                totalPrice:
                  cartResponse?.currencySign +
                    cartResponse?.value?.grandTotal || '',
                cartDiscount:
                  cartResponse?.currencySign +
                    cartResponse?.value?.itemDiscount || '',
                deliveryCharge:
                  cartResponse?.currencySign +
                    cartResponse?.value?.cartDeliveryCharge || '',
                platform: 'equinox',
              },
            })
          }
        } else {
          if (this.props?.isNativeApp === true) {
            try {
              trackErrorInInstana({
                errorReport: 'Triggering Signin Event',
                errorData: {
                  isRegisterUser: customerContainer?.isRegisterUser,
                  customerResponse: JSON.parse(
                    JSON.stringify(customerContainer?.profileResponse)
                  ),
                },
              })
            } catch (e) {
              console.error('error in instana', e)
            }
            sendNeedToSignIn(true)
          } else {
            this.toggleModal({
              visibility: true,
            })
            //Commented this as payment type should be pre-selected for guest and signup user for express payment
            /*checkoutContainer.paypalCheckoutEnable(false)
            checkoutContainer.applePayCheckoutEnable(false)
            checkoutContainer.gPayCheckoutEnable(false)*/
          }
        }
      }
    }
  }

  renderSubscriptionManageText = () => {
    const taxConfig = APPConfig?.getAppConfig()?.taxConfig || {}
    const isInclusiveTaxEnabled =
      (convertToBoolean(taxConfig?.inclusiveTaxEnabled) &&
        !convertToBoolean(taxConfig?.isPriceExclusiveMarket)) ||
      convertToBoolean(taxConfig?.isCategoryTaxenable) ||
      convertToBoolean(taxConfig?.isRegionTaxenable)
    return (
      <div className="view-cart-subscription-text mb-2">
        {!isInclusiveTaxEnabled && (
          <div className="pb-2">
            {i18nTranslate(
              'cart.subscriptionSubTotalText',
              'Subtotal does not include shipping or taxes.'
            )}
          </div>
        )}
        <div>
          {i18nTranslate(
            'cart.subscriptionManageText',
            'You may change or cancel your Subscriptions at any time through your Subscription Dashboard (processing times apply).'
          )}
        </div>
      </div>
    )
  }

  handleAddToSubscription = async (props, emandateCallback) => {
    overlayState.showLoader()
    let response =
      await multipleSubscriptionContainer.updateCartItemsToSubscription(props)

    // Check if error code is EOSUBMAN001 (subscription mandate breach - India market only)
    if (response?.code === 'EOSUBMAN001' && isINMarket()) {
      // Trigger eMandate flow
      if (emandateCallback && typeof emandateCallback === 'function') {
        await emandateCallback(response)
      } else {
        overlayState.hideLoader()
        toastState.setToastMessage(
          response?.message ||
            i18nTranslate(
              'cart.authorizationLimitBreached',
              'Authorization limit exceeded. Please update your payment method.'
            ),
          false
        )
      }
      return
    }

    if (cartContainer.isSuccessResponse(response)) {
      overlayState.hideLoader()
      toastState.setToastMessage(
        i18nTranslate(
          'cart.updateSubscriptionSuccess',
          'Items successfully added to your subscription'
        ),
        true
      )
      this.handleAddToSubscriptionModalClose()
    } else {
      overlayState.hideLoader()
      toastState.setToastMessage(
        response?.message ||
          i18nTranslate(
            'cart.updateSubscriptionFailure',
            'Unable to update your Subscription Dashboard, please try again'
          ),
        false
      )
    }
  }

  handleAddToSelectedSubscriptionList = async () => {
    if (
      multipleSubscriptionContainer.selectedSubscriptionOption ===
      'newSubscription'
    ) {
      let isNativeApp = checkIsNativeApp() || false
      if (isNativeApp) {
        this.props?.history?.push?.(
          `${this.getCheckoutPageName()}?isNativeApp=true`
        )
      } else {
        this.props?.history?.push?.(this.getCheckoutPageName())
      }
    } else {
      const subscriptionId =
        multipleSubscriptionContainer.selectedSubscriptionOption

      if (isINMarket() && subscriptionId) {
        overlayState.showLoader()
        try {
          await multipleSubscriptionContainer.getAllItemSubscriptions(
            subscriptionId
          )
        } finally {
          overlayState.hideLoader()
        }
      }

      multipleSubscriptionContainer.isToShowAddToExistingSubscriptionModal = true
    }
    this.handleSelectSubscriptionModalClose()
  }

  handleRedirectionToSubscription = (subscriptionId = '') => {
    const { defaultLocale = '' } = APPConfig?.getAppConfig() || {}
    const curLocale = defaultLocale || this.curLocale || ''
    const [language = '', country = ''] = curLocale?.includes('_')
      ? curLocale.split('_')
      : curLocale.split('-')
    if (IS_BROWSER && subscriptionId) {
      window.location.href =
        `${window.location.origin}/${country}/${language}`.toLowerCase() +
        `${pageNames?.manageSubscription}?id=${subscriptionId}`
    } else {
      console.error('Subscription ID is empty or undefined')
    }
    this.handleSubscriptionConfirmedModalClose()
  }

  handleRedirectionToHomePage = () => {
    try {
      if (IS_BROWSER) {
        let contextValue
        const shoppingContext = getLocalStorage('shoppingContext') || {}
        if (Object.keys(shoppingContext).length > 0) {
          contextValue = shoppingContext?.context || ''
          let redirectUrl = getMysiteCartUrl()
          window.location.href = redirectUrl
        } else {
          this.props.history.push(pageNames.home)
          localStorage.removeItem('shoppingContext')
        }
      }
    } catch (e) {
      console.error(
        'JSON.parse may be an error Continue Button in OrderConfirmation',
        e
      )
    }
    this.handleSubscriptionConfirmedModalClose()
  }

  handleRedirectionToCheckoutPage = () => {
    let isNativeApp = checkIsNativeApp() || false
    if (isNativeApp) {
      this.props?.history?.push?.(
        `${this.getCheckoutPageName()}?isNativeApp=true`
      )
    } else {
      this.props?.history?.push?.(this.getCheckoutPageName())
    }
    this.handleSubscriptionConfirmedModalClose()
  }

  handleRedirectionToCartPage = () => {
    this.handleSubscriptionConfirmedModalClose()
  }

  handleSubscriptionConfirmedModalClose = () => {
    multipleSubscriptionContainer.isToShowSubscriptionConfirmedModal = false
    multipleSubscriptionContainer.subscriptionOption = 'startNewSubscription'
  }

  handleAddToSubscriptionModalClose = () => {
    multipleSubscriptionContainer.isToShowAddToExistingSubscriptionModal = false
  }

  handleSelectSubscriptionModalClose = () => {
    multipleSubscriptionContainer.isToShowSelectSubscriptionModal = false
  }

  handleSubscriptionOptionChange = value => {
    multipleSubscriptionContainer.subscriptionOption = value
  }

  renderMultiSubscriptionRadioOptions = () => {
    const hasSubscriptionText = i18nTranslate(
      'cartCreateNewSubscriptionComponent.titleText',
      'We noticed you’re subscribing. Do you want to:',
      { isNextGenTranslations: true }
    )

    let subscriptionOptions = multipleSubscriptionRadioOptions()

    return (
      <div className="subscription-radio-options-wrapper">
        <p className="manage-subscription-text">{hasSubscriptionText}</p>
        <div className="subscription-radio-options">
          {subscriptionOptions?.map((option, index) => {
            const {
              name = '',
              value = '',
              labelValue = '',
              id = '',
              dataTestId = '',
              customClass = '',
            } = option

            return (
              <>
                <input
                  type="radio"
                  name={name}
                  aria-label={labelValue}
                  key={'option' + value}
                  id={id}
                  onChange={() => {
                    this.handleSubscriptionOptionChange(value)
                  }}
                  checked={
                    multipleSubscriptionContainer.subscriptionOption === value
                  }
                  data-testId={dataTestId}
                />
                <label
                  htmlFor={id}
                  aria-label={labelValue}
                  className={`${customClass} subscription-option-label-wrapper`}>
                  <div className="subscription-option-label">{labelValue}</div>
                </label>
              </>
            )
          })}
        </div>
      </div>
    )
  }

  renderMultipleSubscriptionOptions = () => {
    const { isFromViewCart = false } = this.props
    const isToShowMultipleSubscriptionOptions =
      isToShowMultipleSubscriptionOptionsInCart()

    const isSubscriptionOverridePage = isToShowOverrideSubscription()

    const isToShowMultipleSubscriptionOptionList =
      isToShowMultipleSubscriptionOptions &&
      isFromViewCart &&
      !isSubscriptionOverridePage

    return (
      isToShowMultipleSubscriptionOptionList && (
        <> {this.renderMultiSubscriptionRadioOptions()} </>
      )
    )
  }
  renderOverrideCartMessage = () => {
    const userName =
      cartContainer.cartResponse?.properties?.subscriptionName ||
      cartContainer.selectedSubscriptionName ||
      ''
    const isSubscriptionOverridePage = isToShowOverrideSubscription()
    if (isSubscriptionOverridePage) {
      return (
        <div className="subscription-override-message-box">
          <div className="view-cart-subscription-override-message">
            <span>
              {i18nTranslate(
                'cart.subscriptionOverrideMessage1',
                "Submitting this override will process this month's items for"
              )}
            </span>
            <span className="subscription-override-username mx-1">
              {userName}
            </span>
            <span>
              {i18nTranslate(
                'cart.subscriptionOverrideMessage2',
                "immediately. It won't affect the regular processing schedule for future orders, but the next scheduled processing day will be skipped."
              )}
            </span>
          </div>
        </div>
      )
    }
  }

  renderOverrideEmptyCartMessage = () => {
    return (
      <p className="subscription-override-empty-message d-flex justify-content-center align-items-center">
        {i18nTranslate(
          'cart.overrideEmptyMessage',
          'There is no item in your cart.'
        )}
      </p>
    )
  }

  render() {
    const subscriptionList =
      nuskinSubscriptionContainer.getSubscriptionList() || []
    let orderProcessingThreshold = {}
    try {
      orderProcessingThreshold = JSON.parse(
        nuskinSubscriptionContainer?.subscriptionPreferenceResponse?.properties
          ?.orderProcessingDateThreshold || {}
      )
    } catch (e) {
      console.log('Parse Error on order processing threshold')
    }
    const toDay = new Date().getDate()
    let blackOutDaysThreshold = []
    let defaultProcessingDate
    for (let blackoutdate in orderProcessingThreshold) {
      if (orderProcessingThreshold[blackoutdate]?.threshold <= 0) {
        blackOutDaysThreshold.push(blackoutdate)
        defaultProcessingDate =
          orderProcessingThreshold[blackoutdate].defaultProcessingDate
      }
    }

    const cartResponse = cartContainer.cartResponse || {}
    const subsTotalProperties = cartContainer?.cartResponse?.properties
    const formattedSubscriptionItemsTotal = this.formatPrice(
      'subsctiptionItemsTotal',
      subsTotalProperties
    )
    const subsctiptionItemsTotal =
      multipleSubscriptionContainer.getSubscriptionItemsTotal()
    const loyaltyAppliedResult = cartResponse?.payments?.find(
      item => item?.type?.toLocaleLowerCase() == 'loyalty'
    )
    const storeCredit = cartContainer.redeemedStoreCreditPoints()
    const currencyCode = cartContainer.cartResponse?.currencyCode || ''
    const promotionDetails =
      cartContainer.cartResponse?.promotionDetails?.promotions || []
    const value = cartContainer.cartResponse?.value || ''
    const balance = cartContainer.cartResponse?.loyalty?.totalPoints || 0
    const initialInput = loyaltyAppliedResult?.amount || 0
    const redeemable =
      cartContainer.cartResponse?.value?.totalLoyaltyPointsToPay || 0
    const {
      className = '',
      isSaveForLater = false,
      isFromViewCart = false,
      isNativeApp = false,
    } = this.props

    const orderTotalLabel =
      this.enableLiveEvent === 'true'
        ? i18nTranslate('cart.orderTotalEvent', 'Order Subtotal')
        : i18nTranslate('cart.orderTotal', 'Order Total')
    const orderTotalTestId =
      this.enableLiveEvent === 'true'
        ? 'qa-cart-order-subtotal'
        : 'qa-cart-order-total'
    const orderTotal = this.formatPrice('grandTotal', value)

    const subscriptionTotalLabel = i18nTranslate(
      'cart.subscriptionTotal',
      'Subscription Subtotal'
    )
    const isCartHasOneTimeProducts = cartContainer.hasOneTimeProducts() || false
    const isCartHasSubscriptionProducts =
      cartContainer.hasSubscriptionProduct() || false
    const isGPSEnabledAndDefault = isGPSEnabled()
    const isToEnableKlarna =
      getAvailablePaymentsForAddNewSections({
        paymentType: 'klarna',
      }) || false
    const isToShowKlarnaOnSiteMessage =
      !isCartHasSubscriptionProducts &&
      isFromViewCart &&
      !isGPSEnabledAndDefault &&
      isToEnableKlarna
    const enableCartSearchBox =
      APPConfig.getAppConfig()?.enableCartSearchBox == 'true'
    let contextValue
    let isMySiteOrPersonalOfferSite = false
    try {
      if (typeof window !== 'undefined') {
        contextValue = isEquinoxMysite() ? '' : checkMysiteOrPersonalOffer()
        if (
          contextValue === 'personal_offer' ||
          contextValue === 'storefront'
        ) {
          isMySiteOrPersonalOfferSite = true
        }
      }
    } catch (e) {
      console.log('Unable to JSON.parse at renderCartViewButtons >>> ', e)
    }

    const isPOSite = isEquinoxPOSite()
    const isToShowOTPSearchBox =
      isFromViewCart &&
      !isNativeApp &&
      ((enableCartSearchBox && !isMySiteOrPersonalOfferSite) ||
        (enableCartSearchBox && isPOSite))

    const itemPromotions = cartContainer.getItemLevelPromotions()
    const isFlexibleSubscriptionEnabled =
      isFlexibleSubscriptionFlagEnabled() || false
    const isMultipleSubscriptionEnabled =
      isMultipleSubscriptionFlagEnabled() || false

    let isRegisterUser = customerContainer?.isRegisterUser || false
    const isShowDrawer =
      blackOutDaysThreshold?.map(Number)?.includes(toDay) && !this.isHandleClick
        ? false
        : true

    const isToShowFlexibleSubscriptionDrawer =
      ((isFromViewCart && this.isToShowSubscriptionModal) ||
        nuskinSubscriptionContainer.isToShowDisabledModal) &&
      isCartHasSubscriptionProducts &&
      !cartContainer.isCartResponseLoading &&
      isRegisterUser &&
      !nuskinSubscriptionContainer.isSubscriptionApiInProgress &&
      isShowDrawer

    const isToShowLegacySubscriptionModal =
      !isFlexibleSubscriptionEnabled &&
      !isMultipleSubscriptionEnabled &&
      ((isFromViewCart && this.isToShowSubscriptionModal) ||
        nuskinSubscriptionContainer.isToShowDisabledModal)

    const blackOutDays =
      blackOutDaysThreshold?.length === 0
        ? subscriptionBlackOutDatesV2
        : blackOutDaysThreshold

    const isToShowBlackOutDateOption =
      isFromViewCart &&
      enableToshowBlackOutDateSelection() &&
      isCartHasSubscriptionProducts &&
      isRegisterUser &&
      !nuskinSubscriptionContainer?.isSubscriptionApiInProgress &&
      subscriptionList.length > 0 &&
      (subscriptionBlackOutDatesV2?.includes(toDay) ||
        blackOutDays?.map(Number)?.includes(toDay))

    if (!isToShowBlackOutDateOption) {
      setSessionStorage('isToShowBlackOut', false)
      nuskinSubscriptionContainer.isToShowBlackOut = false
    }

    const { items = [] } = cartContainer.cartResponse || {}

    const cartSubscriptionItems =
      multipleSubscriptionContainer.getSubscriptionItemsInCart() || []
    const isSubscriptionOverridePage = isToShowOverrideSubscription()

    const isToShowEmptyCartPage =
      cartContainer?.cartCount == 0 &&
      !isSaveForLater &&
      !nuskinSubscriptionContainer.enableGoToCart &&
      !isSubscriptionOverridePage

    const isToShowCSWrapper =
      saveForLaterContainer?.saveForLaterListProducts?.length > 0
        ? isSaveForLater
        : cartContainer?.cartResponse?.items?.length > 0
          ? isFromViewCart
          : false

    return (
      <>
        {!useCartTableView && renderCartProductsHeader(isSaveForLater)}
        {isToShowEmptyCartPage ? (
          <EmptyCart isCheckout={true} isViewCartPage={isFromViewCart} />
        ) : (
          <>
            <SigninModal
              isVisible={this.isModalVisible}
              onHideSignInModal={() => this.toggleModal(false)}
              checkoutUrl={this.props}
            />
            <div
              data-testid="qa-cart-products-inner-container"
              className={`${
                this.props?.isSaveForLater ? 'pb-2 w-100' : 'pb-2'
              } ${
                this.enableLiveEvent === 'true' ? 'live-event-enabled' : ''
              }`}>
              <Row
                noGutters
                className={`product-wrapper ${className} product-bg mx-0 ${
                  isToShowOTPSearchBox ? 'cart-search-wrapper' : ''
                }`}
                data-testid="qa-grouped-products-wrapper">
                <Col className="cart-product-collection col-md-8 col-12 pl-md-0 pr-md-2">
                  {this.renderOverrideCartMessage()}
                  {isToShowOTPSearchBox && this.enableLiveEvent !== 'true' && (
                    <ViewCartSearch />
                  )}
                  {this.renderMultipleSubscriptionOptions()}
                  {isToShowBlackOutDateOption &&
                    this.selectBlackOutDateSubscriptionOptions(
                      defaultProcessingDate
                    )}
                  {this.renderProductBlockView()}
                  {isSubscriptionOverridePage &&
                    items?.length === 0 &&
                    this.renderOverrideEmptyCartMessage()}
                  {isFromViewCart &&
                    isCartHasSubscriptionProducts &&
                    (isFlexibleSubscriptionEnabled ||
                      isMultipleSubscriptionEnabled) &&
                    this.renderSubscriptionManageText()}
                  {isToShowCSWrapper && (
                    <div
                      data-testId="qa-cswrapper-container"
                      className="cart-order-product-cs-wrapper">
                      <CSWrapper zone="Cart Products" {...this.props} />
                    </div>
                  )}
                </Col>
                {this.props?.isSaveForLater ? (
                  <></>
                ) : (
                  <Col className="cart-order-summary col-md-4 col-12 pr-md-0 pl-md-2">
                    <div className="ordr-sumary bg-white" aria-live="polite">
                      <div
                        className="order-sumary-title"
                        data-testid="qa-cart-order-summary">
                        <h3>
                          {i18nTranslate('cart.orderSummary', 'Order Summary')}
                        </h3>
                      </div>
                      <div className="order-sub-total d-flex">
                        <div
                          className="ordr-sub-txt paragraph-m-bold"
                          // aria-hidden={true}
                          data-testid={`${orderTotalTestId}`}>
                          {orderTotalLabel}
                        </div>
                        <div
                          className="ordr-sub-price"
                          data-testid="qa-cart-order-total-price"
                          aria-label={`${orderTotalLabel} ${orderTotal}`}>
                          {' '}
                          {orderTotal}
                        </div>
                      </div>

                      {subsctiptionItemsTotal > 0 && (
                        <div className="ordrs-price-info d-flex">
                          <div
                            className="ordr-total-txt paragraph-l"
                            // aria-hidden={true}
                            data-testid="qa-cart-subscription-sub-total">
                            {subscriptionTotalLabel}
                          </div>
                          <div
                            className="ordr-total-price paragraph-l"
                            data-testid="qa-cart-subscription-total-price"
                            aria-label={`${subscriptionTotalLabel} ${formattedSubscriptionItemsTotal}`}>
                            {formattedSubscriptionItemsTotal}
                          </div>
                        </div>
                      )}

                      <div className="mt-2">
                        <Summary
                          isCheckout={true}
                          customClass="p-0 view-cart-summary-wrapper"
                          itemsPromotions={itemPromotions}
                          math={{
                            ...value,
                            openLoyaltyPoints: balance,
                            redeemedLoyaltyPoints: initialInput,
                            redeemableLoyaltyPoints: redeemable,
                            storeCredit: storeCredit,
                          }}
                          promotionDetails={promotionDetails}
                          currencyCode={currencyCode}
                          showRedeemableSection={true}
                          totalValue={value.priceFacets}
                        />
                      </div>
                      {this.renderCartViewButtons()}
                      {isToShowKlarnaOnSiteMessage &&
                        this.renderKlarnaMessaging()}
                      <LoyaltyMFEContainer
                        componentName="App"
                        isFrom="CART"
                        subscriptionTotal={subsctiptionItemsTotal}
                      />
                    </div>
                    <div className="cart-order-summary-cs-wrapper">
                      <CSWrapper zone="Order Summary" {...this.props} />
                    </div>
                  </Col>
                )}
              </Row>
              {isToShowLegacySubscriptionModal && (
                <MultipleProductSubscriptionModal
                  isToShowModal={
                    this.isToShowSubscriptionModal ||
                    nuskinSubscriptionContainer.isToShowDisabledModal
                  }
                  toggleSubscriptionModal={this.toggleSubscriptionModal}
                  type="cart"
                />
              )}
              {isFlexibleSubscriptionEnabled &&
                isToShowFlexibleSubscriptionDrawer && (
                  <DrawerModal
                    renderView={this.renderFlexibleSubscriptionModal}
                    show={this.isToShowSubscriptionModal}
                    onHide={this.toggleSubscriptionModal}
                    customClass="cart-single-subscription-modal"
                  />
                )}
              {multipleSubscriptionContainer.isToShowSelectSubscriptionModal &&
                isFromViewCart && (
                  <MultipleSubscriptionCart
                    showModal={
                      multipleSubscriptionContainer.isToShowSelectSubscriptionModal
                    }
                    handleSelectSubscriptionModalClose={
                      this.handleSelectSubscriptionModalClose
                    }
                    handleAddToSelectedSubscriptionList={
                      this.handleAddToSelectedSubscriptionList
                    }
                    checkoutDisableInfo={this.checkoutDisable}
                  />
                )}
              {multipleSubscriptionContainer.isToShowAddToExistingSubscriptionModal &&
                isFromViewCart && (
                  <AddToExistingSubscriptionModal
                    handleAddToSubscriptionModalClose={
                      this.handleAddToSubscriptionModalClose
                    }
                    showModal={
                      multipleSubscriptionContainer.isToShowAddToExistingSubscriptionModal
                    }
                    selectedSubscriptionGroup={
                      multipleSubscriptionContainer.selectedSubscriptionOption
                    }
                    cartSubscriptionItems={cartSubscriptionItems}
                    handleAddToSubscription={this.handleAddToSubscription}
                  />
                )}
            </div>
          </>
        )}
        {multipleSubscriptionContainer.isToShowSubscriptionConfirmedModal &&
          isFromViewCart && (
            <div>
              <SubscriptionConfirmedModal
                handleSubscriptionConfirmedModalClose={
                  this.handleSubscriptionConfirmedModalClose
                }
                isCartHasOneTimeProducts={isCartHasOneTimeProducts}
                handleRedirectionToSubscription={
                  this.handleRedirectionToSubscription
                }
                handleRedirectionToHomePage={this.handleRedirectionToHomePage}
                handleRedirectionToCheckoutPage={
                  this.handleRedirectionToCheckoutPage
                }
                handleRedirectionToCartPage={this.handleRedirectionToCartPage}
                showModal={
                  multipleSubscriptionContainer.isToShowSubscriptionConfirmedModal
                }
                selectedSubscriptionGroup={
                  multipleSubscriptionContainer.selectedSubscriptionOption
                }
                cartSubscriptionItems={cartSubscriptionItems}
                subscriptionId={
                  multipleSubscriptionContainer?.selectedSubscriptionOption
                }
              />
            </div>
          )}
      </>
    )
  }
}

export default CartProducts
export { CartProducts }
